import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  inject,
  ViewChild,
} from '@angular/core';
import { startWith } from 'rxjs';
import { changeDeviceView } from 'src/app/common/app.helpers';
import AppValues from 'src/app/common/app.values';
import { MaybeNull } from 'src/app/utils';
import { FormFieldSate } from '../form-field.state';

type ContenteditableAttribute = 'true' | 'false' | 'plaintext-only';

@Component({
  selector: 'app-textarea-form-field',
  templateUrl: './textarea-form-field.component.html',
  styleUrls: ['./textarea-form-field.component.scss'],
})
export class TextareaFormFieldComponent extends FormFieldSate implements AfterViewInit {
  protected counter = 0;

  protected isMobileView = false;
  protected contenteditable: ContenteditableAttribute = 'false';

  protected changeDetector = inject(ChangeDetectorRef);

  @ViewChild('input', { static: false }) private input: MaybeNull<ElementRef<HTMLDivElement>>;

  @HostListener('window:resize')
  public resizeWindow(): void {
    this.isMobileView = changeDeviceView(AppValues.DEFAULT_WIDTH_FOR_MOBILE);
  }

  public override ngOnInit(): void {
    super.ngOnInit();

    this.contenteditable = !this.fieldAttribute.backendAttribute.read_only ? 'plaintext-only' : 'false';
    this.isMobileView = changeDeviceView(AppValues.DEFAULT_WIDTH_FOR_MOBILE);
  }

  public ngAfterViewInit(): void {
    const controlValue = this.control.value as string;

    if (this.input) {
      this.input.nativeElement.innerText = controlValue;
    }

    this.subscriptions.push(
      this.control.valueChanges.pipe(startWith(controlValue)).subscribe((value: string) => {
        value = value ?? '';

        this.counter = value === '\n' ? 0 : value.length;
        this.changeDetector.detectChanges();
      }),
    );
  }

  public updateFormControl(input: HTMLElement): void {
    this.control.setValue(input.innerText);
    this.control.markAsTouched();
  }

  public onBlur(input: HTMLElement): void {
    this.control.markAsTouched();
    this.trimControlValue(input);
  }

  private trimControlValue(input: HTMLElement): void {
    const value = input.innerText.trim();

    input.textContent = value;
    this.control.setValue(value);
  }
}
